/**
 * 集团订单校验
 */
import { useEffect } from 'react';
import { matchPath } from 'react-router-dom';

import { OrderDetailPageList } from '@/hooks/useOrderLink';
import Storage from '@/utils/storage';

import useDetailDetector from './index';

const Index = () => {
  const { runDetailDetector } = useDetailDetector();

  useEffect(() => {
    const currentPath = window.location.pathname;
    const matchItem = OrderDetailPageList.find((item) =>
      matchPath(currentPath, { path: item.route, exact: true }),
    );
    if (Storage.get('isGroupLogin') && matchItem) {
      // 集团登录 校验订单门店
      runDetailDetector(matchItem.type);
    }
  }, []);

  return null;
};

export default Index;
